export default {
  edit_selection: 'Rediger valg',
};
